import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import * as Actions from 'actions';
import { Tab, Nav, Row, Col, NavItem } from 'react-bootstrap';
import { IncidentList, IncidentPreview } from './incidents';

import { WidgetClientDamageIncidents, ClientDetails, ClientContacts, NewDamageIncidentForm } from './';

class ClientDamageIncidents extends React.Component {
  constructor(props) {
    super(props);
    this.selectIncident = this.selectIncident.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

  }
  componentWillMount() {
    this.props.fetchRecentImpacts(this.props.client._id);
    this.props.fetchIncidents(this.props.client._id || this.props.client);
    this.selectIncident({ _id : this.props.params.incidentId });
  }

  componentDidMount() {
    const resizeIncidentPreview = f => {

      const window_height = $(window).height();
      const offset = $(this.refs.incidentContainer).offset().top;
      $(this.refs.incidentContainer).height(window_height - offset);
    }
    $(window).on('resize.incidents-container', resizeIncidentPreview);
    resizeIncidentPreview();
  }

  componentWillUnmount() {
    $(window).off('resize.incidents-container');
  }
  selectIncident(incident) {
    this.props.previewIncident(incident);
  }

  handleScroll(event) {
    const total = event.target.scrollHeight;
    const to_top  = event.target.scrollTop;
    const height = event.target.clientHeight;
    const current = to_top + height;

    if(current + 50 >= total && !this.props.downloading_incidents && this.props.incidents.length < this.props.total) {
      // this.props.fetchNext();
    }
  }
  componentWillUpdate(nextProps,nextState) {
    const oldId = this.props.params.incidentId;
    const newId = nextProps.params.incidentId;
    if(newId != oldId) {
      this.selectIncident({ _id : newId });
    }
  }
  render() {
    const date = new Date();
    const now = days => moment(date.setDate(date.getDate() - days));

    return (
      <div ref="incidentContainer" className="client-jobs jobs-container">
          <div className="job-list-container">
            <div className="container-title clearfix">
              <div onClick={this.props.startCreateIncident} className="pull-right btn btn-default"><i className="fa fa-plus"></i></div>
              <h3 className="pull-left">Damage Incidents {this.props.downloading_incidents ? <i className="fa fa-spinner fa-spin"></i> : ''}</h3>
            </div>

            <div onScroll={this.handleScroll.bind(this)} className="container-content">
              <IncidentList onSelect={this.selectIncident}/>
            </div>
          </div>
          <div className="job-preview-container">
            <IncidentPreview/>
          </div>
      </div>
    );
  }
}

ClientDamageIncidents.contextTypes = {
  client : PropTypes.object,
}

const mapStateToProps = ({ client, client_incidents }) => ({ client, ...client_incidents });

export default connect(mapStateToProps, Actions)(ClientDamageIncidents);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-damage-incidents.js